/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
import moment from 'moment-timezone';
import React, {
  useEffect, useMemo, useState, useContext,
} from 'react';
import { useLocation, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import {
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Modal, Box,
} from '@mui/material';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import {
  ChevronRight, Download, Plus, Calendar as CalendarIcon, Globe, ChevronDown, ArrowLeft, Info, X,
} from 'lucide-react';
import DateRangePicker from 'rsuite/esm/DateRangePicker';
import DSDateRangePicker from '../../components/dateRangePicker';
import DatePicker from '../../components/datePicker';
import { getDatesInRange, getWeekRange, convertSecToTimeFormat } from '../../utils/time';
import SnapshotRow from './SnapshotRow';
import AuditRow from './AuditRow';
import API from '../../api/endpoints';
import { sendRequest } from '../../api/shootAPI';
import './viewActivity.css';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import UrlActivity from './UrlActivity';
import AppActivity from './AppActivity';
import { getMemberRoleLevel } from '../../utils/permissions';
import { accountTypeLevel } from '../../constants/accountTypes';
import ManualTimeModal from './ManualTimeModal';
import { Navbar, Sidebar } from '../../components';
import { exportTableData, generateActivityReport, transformToTableData } from '../../utils/report';

const AVATAR_PALETTE = [
  { bg: '#fdebe6', fg: '#b94f3c' },
  { bg: '#fde6d2', fg: '#F19235' },
  { bg: '#eef5ea', fg: '#53A551' },
  { bg: '#e8eef7', fg: '#4062E5' },
  { bg: '#f5e6f7', fg: '#9333ea' },
];

function avatarColors(key) {
  const str = String(key || '');
  let h = 0;
  for (let i = 0; i < str.length; i += 1) h = ((h * 31) + str.charCodeAt(i)) & 0xffffffff;
  return AVATAR_PALETTE[Math.abs(h) % AVATAR_PALETTE.length];
}

function initialsFrom(firstName, lastName, email) {
  if (firstName && lastName) return `${firstName[0]}${lastName[0]}`.toUpperCase();
  if (email) return email.slice(0, 2).toUpperCase();
  return '?';
}

function activityColor(value) {
  const v = Number.isFinite(value) ? value : 0;
  if (v >= 70) return '#53A551';
  if (v >= 40) return '#F19235';
  return '#b94f3c';
}

const PROJECT_PALETTE = [
  '#9C27B0', '#E91E63', '#3F51B5', '#2196F3', '#00BCD4',
  '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FF9800',
  '#FF5722', '#795548',
];

function projectColor(projectName, projectId) {
  if (projectId != null && projectId !== 'no-project') {
    const n = parseInt(projectId, 10);
    if (Number.isFinite(n)) return PROJECT_PALETTE[Math.abs(n) % PROJECT_PALETTE.length];
  }
  const name = String(projectName || '?');
  return PROJECT_PALETTE[name.length % PROJECT_PALETTE.length];
}

const ACTIVITY_META = [
  { id: 'deep', label: 'Deep Focused', letter: 'D', color: '#213D69' },
  { id: 'focused', label: 'Focused', letter: 'F', color: '#5A81BC' },
  { id: 'active', label: 'Active', letter: 'A', color: '#B5BAC4' },
  { id: 'break', label: 'Work Break', letter: 'W', color: '#F19235', noScore: true },
  { id: 'manual', label: 'Manual Hours', letter: 'M', color: '#213D69', noScore: true },
];

function ActivityBadge({ activityId, size = 28 }) {
  const a = ACTIVITY_META.find((x) => x.id === activityId);
  return (
    <div
      className="rounded-full flex items-center justify-center text-white flex-shrink-0"
      style={{
        width: size,
        height: size,
        backgroundColor: a?.color ?? '#B5BAC4',
        fontSize: '12px',
        fontWeight: 600,
      }}
    >
      {a?.letter ?? '?'}
    </div>
  );
}

function shortTimezone(tz) {
  if (!tz) return '—';
  const parts = String(tz).split('/');
  return parts[parts.length - 1].replace(/_/g, ' ');
}

// Pill-styled wrapper around the rsuite DatePicker matching the design's DateButton.
// We render a custom button that visually matches design, plus a hidden DatePicker
// that the button triggers via ref.
// NOTE: moment.js format tokens — use `ddd` (short weekday), `D` (day of month),
// `YYYY` (4-digit year). date-fns tokens like `EEE`/`d`/`yyyy` would silently break.
function PillDateButton({ value, onChange, format: fmt = 'ddd, MMM D, YYYY' }) {
  const label = value ? moment(value).format(fmt) : 'Pick a date';
  const inputRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [hover, setHover] = React.useState(false);

  // Detect when the rsuite picker popover closes (mousedown outside the wrapper)
  React.useEffect(() => {
    if (!open) return undefined;
    const handle = (e) => {
      // rsuite renders its popover into document.body via a portal — keep open
      // as long as a click is inside the picker menu OR the wrapper.
      const menu = document.querySelector('.rs-picker-menu');
      if (
        inputRef.current?.contains(e.target)
        || (menu && menu.contains(e.target))
      ) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [open]);

  const active = open || hover;
  return (
    <span className="relative inline-block">
      <button
        type="button"
        onClick={() => {
          const el = inputRef.current?.querySelector('input');
          if (el) el.click();
          setOpen(true);
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className="inline-flex items-center gap-2 h-10 px-3 rounded-[8px] text-ink-900 transition"
        style={{
          border: `1px solid ${active ? '#53A551' : '#e0e1e6'}`,
          backgroundColor: active ? '#eef5ea' : '#ffffff',
          fontSize: '14px',
          fontWeight: 500,
        }}
      >
        <span className="whitespace-nowrap">{label}</span>
        <CalendarIcon size={14} className="flex-shrink-0" style={{ color: '#53A551' }} />
      </button>
      <span
        ref={inputRef}
        style={{
          position: 'absolute',
          left: 0,
          top: '100%',
          width: 0,
          height: 0,
          overflow: 'hidden',
          opacity: 0,
          pointerEvents: 'none',
        }}
      >
        <DatePicker
          value={value}
          onChange={(d) => {
            onChange(d);
            setOpen(false);
          }}
          format="EEE, dd MMM yyyy"
        />
      </span>
    </span>
  );
}

function PillTimezoneSelect({
  value, onChange, options, disabled,
}) {
  return (
    <span
      className={`relative inline-flex items-center gap-2 h-10 px-3 rounded-[8px] bg-white text-ink-900 transition ${disabled ? '' : 'hover:border-brand-500'}`}
      style={{ border: '1px solid #e0e1e6' }}
    >
      <Globe size={14} className="flex-shrink-0" style={{ color: '#3d5a8a' }} />
      <span style={{ fontSize: '14px', fontWeight: 500 }} className="whitespace-nowrap">
        {shortTimezone(value)}
      </span>
      <ChevronDown size={12} className="flex-shrink-0 text-ink-500" />
      <select
        value={value}
        disabled={disabled}
        onChange={onChange}
        className="absolute inset-0 opacity-0 cursor-pointer"
        style={{ width: '100%', height: '100%' }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </span>
  );
}

// Takes the minutes value of the start time as the [key]--the value is the
// array position for displaying the activity in the UI
const MINUTES_DISPLAY_POSITION = {
  0: 0,
  10: 1,
  20: 2,
  30: 3,
  40: 4,
  50: 5,
};

// Breaks the snapshots into 10 minute intervals
const formatSnapshotsByHour = (timezone, snapshots = [], manualEntries = []) => {
  const formattedManualEntries = manualEntries.flatMap((entry) => {
    const chunks = [];
    let start = moment.utc(entry.startTime).tz(timezone);
    const end = moment.utc(entry.endTime).tz(timezone);

    while (start.isBefore(end)) {
      const chunkEnd = moment.min(start.clone().add(10, 'minutes'), end);

      chunks.push({
        timeSlot: start.clone().utc().format(), // keep UTC time format
        _source: 'manual',
        entry,
      });

      start = chunkEnd;
    }

    return chunks;
  });

  const allEntries = [
    ...snapshots.map((snapshot) => ({ ...snapshot, _source: 'automated' })),
    ...formattedManualEntries,
  ];

  return allEntries.reduce((reducer, entry) => {
    const timeSlot = moment.utc(entry.timeSlot).tz(timezone);
    const hour = timeSlot.hours();
    const minutes = timeSlot.minutes();

    const formattedSnapshot = {
      data: entry._source === 'manual' ? entry.entry : entry,
      localStartTime: timeSlot.format('h:mm A'),
      localBlockTime: timeSlot.format('h:mm A'),
      roundedStartTime: timeSlot.format('h:mm A'),
      roundedEndTime: timeSlot.clone().add(10, 'minutes').format('h:mm A'),
      isManual: entry._source === 'manual',
    };

    const snapshotList = reducer[hour] ?? [null, null, null, null, null, null];
    const position = MINUTES_DISPLAY_POSITION[minutes] ?? -1;

    if (position !== -1) {
      snapshotList[position] = formattedSnapshot;
    }

    return { ...reducer, [hour]: snapshotList };
  }, {});
};

const primaryProjectIdFromHistory = (ph = []) => {
  if (!Array.isArray(ph) || ph.length === 0) return null;
  const ranked = ph
    .filter((e) => e && e.projectId != null)
    .map((e) => ({
      id: e.projectId,
      sec: Number(e.secondsElapsed) || Number(e.timeSpent) || 0,
    }));
  if (ranked.length === 0) return null;
  ranked.sort((a, b) => b.sec - a.sec);
  return ranked[0].id ?? null;
};

const projectfulSecondsOfSnapshot = (snapshot) => {
  const ph = Array.isArray(snapshot?.projectHistory) ? snapshot.projectHistory : [];
  return ph
    .filter((e) => e && e.projectId != null)
    .reduce(
      (acc, e) => ({
        total: acc.total + (Number(e.secondsElapsed) || Number(e.timeSpent) || 0),
        active: acc.active + (Number(e.activeSeconds) || 0),
      }),
      { total: 0, active: 0 },
    );
};

const groupByDomain = (browserHistory, activityData = {}) => {
  if (!browserHistory || browserHistory.length === 0) return {};

  const totalUrls = browserHistory.length || 1;
  const timePerUrl = (activityData.totalSecondsElapsed || 0) / totalUrls;
  const activeTimePerUrl = (activityData.totalActiveSeconds || 0) / totalUrls;

  return browserHistory.reduce((acc, item) => {
    if (!item.url) return acc;

    try {
      const url = new URL(item.url);
      const domain = url.hostname;

      if (!acc[domain]) {
        acc[domain] = {
          totalActiveSeconds: 0,
          totalTimeSpent: 0,
          totalVisits: 0,
          urls: [],
        };
      }

      const urlTimeSpent = Math.round(timePerUrl);
      const urlActiveTime = Math.round(activeTimePerUrl);

      acc[domain].totalActiveSeconds += urlActiveTime;
      acc[domain].totalTimeSpent += urlTimeSpent;
      acc[domain].totalVisits += 1;

      acc[domain].urls.push({
        url: item.url,
        title: item.title || '',
        activeSeconds: urlActiveTime,
        secondsElapsed: urlTimeSpent,
        timeSpent: urlTimeSpent,
        domain,
        projectId: activityData.primaryProjectId ?? null,
        timeSlot: activityData.timeSlot || item.timeSlot || null,
        browserName: item.browserName || 'Google Chrome',
      });
    } catch (error) {
      console.error('Invalid URL:', item.url, error);
    }

    return acc;
  }, {});
};

const formatActivityByHour = (timezone, activities) => activities.reduce((acc, activity) => {
  const hour = moment.utc(activity.timeSlot).tz(timezone).hours();
  const localTime = moment.utc(activity.timeSlot).tz(timezone);

  const hourData = acc[hour] || {
    totalActiveSeconds: 0,
    totalSecondsElapsed: 0,
    totalMeetingTime: 0,
    totalMeetingPercentage: 0,
    appActivity: {},
    browserActivity: {},
  };

  const primaryProjectId = primaryProjectIdFromHistory(activity.projectHistory);
  const phTotals = projectfulSecondsOfSnapshot(activity);
  const projfulSeconds = phTotals.total;
  const projfulActive = phTotals.active;

  const mergedApps = activity.appHistory.reduce((apps, app) => {
    const existing = apps[app.applicationName] || {
      time: 0,
      timeInSeconds: 0,
      sessions: 0,
      projectId: null,
    };

    const appTime = app.activeSeconds || (projfulSeconds / Math.max(1, activity.appHistory.length));
    return {
      ...apps,
      [app.applicationName]: {
        ...existing,
        time: existing.time + appTime,
        timeInSeconds: existing.timeInSeconds + appTime,
        sessions: existing.sessions + 1,
        projectId: primaryProjectId,
      },
    };
  }, { ...hourData.appActivity });

  const activityContext = {
    projectId: primaryProjectId,
    timeSlot: activity.timeSlot,
    totalSecondsElapsed: projfulSeconds,
    totalActiveSeconds: projfulActive,
  };

  const groupedBrowserActivity = groupByDomain(activity.browserHistory, activityContext);

  const mergedBrowserActivity = { ...hourData.browserActivity };
  Object.keys(groupedBrowserActivity).forEach((domain) => {
    if (mergedBrowserActivity[domain]) {
      mergedBrowserActivity[domain] = {
        totalActiveSeconds: mergedBrowserActivity[domain].totalActiveSeconds
        + groupedBrowserActivity[domain].totalActiveSeconds,
        totalTimeSpent: mergedBrowserActivity[domain].totalTimeSpent
        + groupedBrowserActivity[domain].totalTimeSpent,
        totalVisits: mergedBrowserActivity[domain].totalVisits + groupedBrowserActivity[domain].totalVisits,
        urls: [...mergedBrowserActivity[domain].urls, ...groupedBrowserActivity[domain].urls],
      };
    } else {
      mergedBrowserActivity[domain] = groupedBrowserActivity[domain];
    }
  });

  return {
    ...acc,
    [hour]: {
      totalActiveSeconds: hourData.totalActiveSeconds + projfulActive,
      totalSecondsElapsed: hourData.totalSecondsElapsed + projfulSeconds,
      totalMeetingTime: hourData.totalMeetingTime + activity.meetingTime,
      totalMeetingPercentage: hourData.totalMeetingPercentage + activity.meetingPercentage,
      localStartTime: localTime.format('h:mm A'),
      localBlockTime: localTime.format('h:mm A'),
      roundedStartTime: localTime.format('h:mm A'),
      roundedEndTime: localTime.clone().add(10, 'minutes').format('h:mm A'),
      appActivity: mergedApps,
      browserActivity: mergedBrowserActivity,
      projectId: primaryProjectId,
      timeSlot: activity.timeSlot,
    },
  };
}, {});

const formatWebcamAuditByDay = (timezone, webcamAudits) => webcamAudits.reduce((reducer, webcamAudit) => {
  // iterate through each webcam audit and bucket them by day (UTC time)
  // Output:
  // {
  //   2023/07/03: [/* all webcam audits withiin this day will go in here */] }
  // }
  const localTime = moment.utc(webcamAudit.timestamp).tz(timezone).format('h:mm A');
  const localDate = moment.utc(webcamAudit.timestamp).tz(timezone).format('YYYY/MM/DD');

  const formattedWebcamAudit = {
    data: webcamAudit,
    localTime,
  };

  const webcamAuditList = reducer[localDate]
    ?? [];
  webcamAuditList.push(formattedWebcamAudit);
  return { ...reducer, [localDate]: webcamAuditList };
}, {});

const getTableTimeAndAcitivity = (
  activities,
  dates,
  timezone,
  manualData = [],
  offTimeData = [],
  holidayData = {},
) => {
  const times = [];
  const avgActivities = [];
  let totalSecondsElapsed = 0;
  let totalActiveSeconds = 0;
  let totalManualTime = 0;
  const manualTimes = [];
  const ptoTimes = [];
  const ptoData = [];
  // Holidays arrive keyed by their own calendar date (see HolidayService on the
  // server), so a holiday dated 4 Sep renders on the 4 Sep column for every
  // member assigned to it, whatever shift they work.
  const holidayFlags = [];
  const holidayNames = [];
  const holidayZones = [];
  const holidayTimes = [];

  const totalPtoTime = offTimeData.reduce((sum, pto) => sum + Number(pto.totalHours || 0) * 60, 0);
  dates.forEach((day) => {
    const startDay = moment.tz(day, 'MM/DD/YYYY', timezone).startOf('day').utc();
    const endDay = moment.tz(day, 'MM/DD/YYYY', timezone).endOf('day').utc();

    const dailyManualTime = manualData.reduce((acc, manual) => {
      const manualStart = moment.utc(manual.startTime);
      if (manualStart.isSameOrAfter(startDay) && manualStart.isSameOrBefore(endDay)) {
        return acc + (manual.durationSeconds || 0);
      }
      return acc;
    }, 0);

    const ptoEntry = offTimeData.find((pto) => moment.utc(pto.date).isSame(moment.utc(day, 'MM/DD/YYYY'), 'day'));
    const dailyPtoTime = ptoEntry ? Number(ptoEntry.totalHours || 0) * 60 : 0;

    ptoTimes.push(moment.utc(dailyPtoTime * 1000).format('H:mm:ss'));
    ptoData.push(dailyPtoTime > 0);

    const dayHolidays = holidayData[moment(day, 'MM/DD/YYYY').format('YYYY-MM-DD')] || [];
    holidayFlags.push(dayHolidays.length > 0);
    holidayNames.push(dayHolidays.map((h) => h.name).join(', '));
    holidayZones.push(dayHolidays.map((h) => h.timezone).join(', '));
    // Paid holiday hours are shown but deliberately NOT folded into the day's
    // total: a member who worked the holiday already had their full worked time
    // credited as PTO by accumulatePTO, so adding the paid hours on top would
    // double-count them.
    holidayTimes.push(dayHolidays
      .map((h) => String(h.paidHours || '')).filter(Boolean).join(', '));

    const initialdateActivity = { secondsElapsed: 0, activeSeconds: 0, manualTime: 0 };
    const dateActivity = activities.reduce(
      (acc, activity) => {
        const compareDay = moment.utc(activity.startDate);

        if (compareDay.isSameOrAfter(startDay) && compareDay.isSameOrBefore(endDay)) {
          return {
            secondsElapsed: acc.secondsElapsed + activity.secondsElapsed,
            activeSeconds: acc.activeSeconds + activity.activeSeconds,
            manualTime: acc.manualTime + (activity.manualTime || 0),
          };
        }
        return { ...acc };
      },
      initialdateActivity,
    );
    totalSecondsElapsed += dateActivity.secondsElapsed;
    totalActiveSeconds += dateActivity.activeSeconds;
    totalManualTime += dateActivity.manualTime;
    totalManualTime += dailyManualTime;

    times.push(moment.utc(
      (dateActivity.secondsElapsed + dailyManualTime + dailyPtoTime) * 1000,
    ).format('H:mm:ss'));
    manualTimes.push(moment.utc(dailyManualTime * 1000).format('H:mm:ss'));

    const avgActivity = dateActivity.secondsElapsed
      ? Number((((dateActivity.activeSeconds / dateActivity.secondsElapsed) || 0) * 100).toFixed(0))
      : null;
    avgActivities.push(avgActivity);
  });
  const totalTime = convertSecToTimeFormat(totalSecondsElapsed + totalManualTime + totalPtoTime);
  const totalAvgActivity = totalSecondsElapsed
    ? Number((((totalActiveSeconds / totalSecondsElapsed) || 0) * 100).toFixed(0))
    : null;
  return {
    times,
    avgActivities,
    totalTime,
    totalAvgActivity,
    manualTimes,
    totalManualTime: moment.utc(totalManualTime * 1000).format('H:mm:ss'),
    totalPtoTime: moment.utc(totalPtoTime * 1000).format('H:mm:ss'),
    ptoTimes,
    ptoData,
    holidayFlags,
    holidayNames,
    holidayZones,
    holidayTimes,
  };
};

const calculateProjectTableData = (activities, dates, timezone, projects, manualEntries = []) => {
  const projectData = {};

  let projectsArray = [];

  if (Array.isArray(projects)) {
    projectsArray = projects;
  } else if (projects && typeof projects === 'object') {
    if (projects.projects && Array.isArray(projects.projects)) {
      projectsArray = projects.projects;
    } else if (projects.data && Array.isArray(projects.data)) {
      projectsArray = projects.data;
    } else if (projects.list && Array.isArray(projects.list)) {
      projectsArray = projects.list;
    } else {
      projectsArray = Object.values(projects);
    }
  }

  projectsArray.forEach((project) => {
    if (project && project.id && project.name) {
      projectData[project.id] = {
        name: project.name,
        times: [],
        totalSeconds: 0,
      };
    }
  });

  projectData['no-project'] = {
    name: 'No Project',
    times: [],
    totalSeconds: 0,
  };

  dates.forEach((day) => {
    const startDay = moment.tz(day, 'MM/DD/YYYY', timezone).startOf('day').utc();
    const endDay = moment.tz(day, 'MM/DD/YYYY', timezone).endOf('day').utc();

    const dailyProjectTimes = {};
    projectsArray.forEach((project) => {
      if (project && project.id) {
        dailyProjectTimes[project.id] = 0;
      }
    });
    dailyProjectTimes['no-project'] = 0;

    activities.forEach((activity) => {
      const activityStart = moment.utc(activity.startDate);
      if (!activityStart.isSameOrAfter(startDay) || !activityStart.isSameOrBefore(endDay)) return;
      const ph = Array.isArray(activity.projectHistory) ? activity.projectHistory : [];
      ph.forEach((e) => {
        if (!e || e.projectId == null) return;
        const pid = e.projectId;
        const inc = Number(e.secondsElapsed) || Number(e.timeSpent) || 0;
        dailyProjectTimes[pid] = (dailyProjectTimes[pid] || 0) + inc;
      });
    });

    manualEntries.forEach((manual) => {
      const manualStart = moment.utc(manual.startTime);
      if (manualStart.isSameOrAfter(startDay) && manualStart.isSameOrBefore(endDay)) {
        const projectId = manual.projectId || 'no-project';
        dailyProjectTimes[projectId] = (dailyProjectTimes[projectId] || 0) + (manual.durationSeconds || 0);
      }
    });

    Object.keys(dailyProjectTimes).forEach((projectId) => {
      const timeFormatted = moment.utc(dailyProjectTimes[projectId] * 1000).format('H:mm:ss');
      if (projectData[projectId]) {
        projectData[projectId].times.push(timeFormatted);
        projectData[projectId].totalSeconds += dailyProjectTimes[projectId];
      }
    });
  });

  Object.keys(projectData).forEach((projectId) => {
    projectData[projectId].totalTime = convertSecToTimeFormat(projectData[projectId].totalSeconds);
  });

  return projectData;
};

const SCREENSHOT_TABS = [
  { id: 0, label: 'Screenshot' },
  { id: 1, label: 'Webcam Audit' },
  { id: 2, label: 'URL Activity' },
  { id: 3, label: 'App Activity' },
];

const tabOptions = [
  { label: 'Daily' },
  { label: 'Weekly' },
];

const headers = [
  {
    label: 'Date',
    key: 'date',
  },
  {
    label: 'Total Hours',
    key: 'totalSeconds',
  },
  {
    label: 'Total Activity',
    key: 'totalActivity',
  },
  {
    label: 'Deep Focused Hours',
    key: 'deepFocused',
  },
  {
    label: 'Deep Focused Activity',
    key: 'deepFocusedActivity',
  },
  {
    label: 'Focused Hours',
    key: 'focused',
  },
  {
    label: 'Focused Activity',
    key: 'focusedActivity',
  },
  {
    label: 'Active Hours',
    key: 'active',
  },
  {
    label: 'Active Activity',
    key: 'activeActivity',
  },
  {
    label: 'Work Break Hours',
    key: 'workBreak',
  },
];

function ViewActivity() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const memberId = queryParams.get('member');
  // Deep links from email (e.g. the Schedule Adherence alert) can only carry
  // query params, not React Router state, so a `date=YYYY-MM-DD` param selects
  // the day. An unparseable value falls through to the normal default rather
  // than opening the screen on an Invalid Date.
  const dateParam = queryParams.get('date');
  const linkedDate = dateParam && moment(dateParam, 'YYYY-MM-DD', true).isValid()
    ? moment(dateParam, 'YYYY-MM-DD').toDate()
    : null;
  const { activeWorkspace, user, member: curMember } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const {
    workspaceMember: member,
    previouslySelectedDate,
  } = location.state || {};
  const isAdmin = getMemberRoleLevel(curMember) >= accountTypeLevel['Workspace admin'];
  const addable = isAdmin; // For backward compatibility with existing code
  const [activityType, setActivityType] = useState(location.state?.activityType ?? 'Screenshots');
  // An explicit ?date= wins over the remembered date: the link was clicked to
  // look at that specific day.
  const [date, setDate] = useState(linkedDate ?? previouslySelectedDate ?? new Date());
  const [snapshots, setSnapshots] = useState({ data: [], formatted: {} });
  const [additionalTracking, setAdditionalTracking] = useState({});
  const [webcamAudits, setWebcamAudits] = useState({ data: [], formatted: {} });
  const [collapseTable, setCollapseTable] = useState(false);
  const [showCaptures, setShowCaptures] = useState(false);
  const [tableData, setTableData] = useState({
    dates: [],
    times: [],
    avgActivities: [],
    totalTime: '0:00:00',
    totalAvgActivity: null,
    isReportingManager: false,
    manualTimes: [],
    totalManualTime: '0:00:00',
    ptoData: [],
  });
  const [selectedActivity, setSelectedActivity] = useState([]);
  const [selectedManualTime, setSelectedManualTime] = useState([]);
  const [selectedTimezone, setSelectedTimezone] = useState(activeWorkspace.timezone);
  // Standalone (member portal) entry: no drill-down state and no ?member= param
  // → show the current member's own timesheet, and hide the back button.
  const isSelfView = !member && !memberId;
  // Context stores `member` and `user` separately; the view expects a member
  // with a nested `.user`, so compose one for the self (member-portal) view.
  const [workspaceMember, setWorkspaceMember] = useState(
    member || (isSelfView && curMember ? { ...curMember, user: curMember.user || user } : undefined),
  );
  const [value, setValue] = useState(0);
  const [showAddTimeModal, setShowAddTimeModal] = useState(false);
  const [tabValue, setTabValue] = useState('Weekly');
  const history = useHistory();

  const today = new Date();
  const [dailyDate, setDailyDate] = useState([new Date(moment(today).subtract(6, 'days')), today]);
  const [dailyActivities, setDailyActivities] = useState([]);
  const [dailyTableData, setDailyTableData] = useState([]);
  const [exportData, setExportData] = useState([]);
  // Range export (member's own timesheet → CSV, built client-side, timezone-aware)
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportRange, setExportRange] = useState([new Date(), new Date()]);
  const [rangeCsvRows, setRangeCsvRows] = useState([]);
  const [rangeCsvFilename, setRangeCsvFilename] = useState('Timesheet.csv');
  const [isExporting, setIsExporting] = useState(false);
  const rangeCsvRef = React.useRef(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [activityToDelete, setActivityToDelete] = useState(null);
  const [deletingActivityId, setDeletingActivityId] = useState(null);
  const [openDays, setOpenDays] = useState(new Set([0]));

  const toggleDailyDay = (idx) => {
    setOpenDays((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx); else next.add(idx);
      return next;
    });
  };

  const fetchDailyActivities = async () => {
    const [startDate, endDate] = dailyDate;
    const dates = getDatesInRange(startDate, endDate);
    const startOfDay = moment.tz(dates[0], selectedTimezone).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = moment.tz(dates.at(-1), selectedTimezone).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    const { success, data } = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.memberDailyActivity(activeWorkspace.id, memberId),
      params: {
        start: startOfDay,
        end: endOfDay,
      },
    });
    if (success) {
      setDailyActivities(data.dailyActivities);
    } else {
      displayNotification({
        message: 'There was an issue fetching daily activity data of this member. Please try again',
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    if (tabValue === 'Daily') {
      fetchDailyActivities();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue, dailyDate, selectedTimezone]);

  useEffect(() => {
    const res = generateActivityReport([{ dailyActivity: dailyActivities }], dailyDate[0], dailyDate[1]);
    setExportData(exportTableData(res));
    setDailyTableData(transformToTableData(res));
  }, [dailyActivities]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getTableData = async (selectedDate, timezone = selectedTimezone) => {
    const weekRange = getWeekRange(selectedDate);
    const dates = getDatesInRange(new Date(weekRange.start), new Date(weekRange.end));
    const startOfDate = moment(dates[0]).startOf('day');
    const endOfDate = moment(dates[6]).endOf('day');
    const params = {
      start: startOfDate.format('YYYY-MM-DD HH:mm:ss'),
      end: endOfDate.format('YYYY-MM-DD HH:mm:ss'),
      timezone,
    };

    try {
      const res = await sendRequest({
        method: 'get',
        url: API.MEMBER.activityList(workspaceMember.id),
        params,
      });

      if (res.success) {
        const data = res?.data?.list || [];
        const manualEntries = res?.data?.manualEntries || [];
        const projects = res?.data?.projects || [];
        const offTimeRequests = res?.data?.offTimeRequests || [];
        const holidays = res?.data?.holidays || {};

        const {
          times, avgActivities, totalTime, totalAvgActivity, manualTimes, totalManualTime, ptoData,
          holidayFlags, holidayNames, holidayZones, holidayTimes,
        } = getTableTimeAndAcitivity(data, dates, timezone, manualEntries, offTimeRequests, holidays);

        const projectTableData = calculateProjectTableData(data, dates, timezone, projects, manualEntries);

        setTableData({
          dates,
          times,
          avgActivities,
          totalTime,
          totalAvgActivity,
          manualTimes,
          totalManualTime,
          ptoData,
          holidayFlags,
          holidayNames,
          holidayZones,
          holidayTimes,
          projectTableData,
          projects,
          isReportingManager: (res.data.isReportingManager
            || getMemberRoleLevel(curMember) >= accountTypeLevel['Workspace admin']),
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Build a CSV of the member's own daily totals for the picked range, in the
  // selected timezone, reusing the same per-day aggregation as the table.
  const handleExportTimesheet = async () => {
    if (!workspaceMember?.id) return;
    setIsExporting(true);
    const [start, end] = exportRange;
    const dates = getDatesInRange(new Date(start), new Date(end));
    const params = {
      start: moment(dates[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end: moment(dates.at(-1)).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      timezone: selectedTimezone,
    };
    try {
      const res = await sendRequest({ method: 'get', url: API.MEMBER.activityList(workspaceMember.id), params });
      if (res.success) {
        const list = res?.data?.list || [];
        const manualEntries = res?.data?.manualEntries || [];
        const offTimeRequests = res?.data?.offTimeRequests || [];
        const holidays = res?.data?.holidays || {};
        const { times, holidayNames } = getTableTimeAndAcitivity(list, dates, selectedTimezone, manualEntries, offTimeRequests, holidays);
        const name = `${workspaceMember.user?.firstName || ''} ${workspaceMember.user?.lastName || ''}`.trim() || (workspaceMember.user?.email || 'Member');
        // Total = exact sum of the per-day columns shown in the row (non-wrapping).
        const hmsToSec = (t) => {
          const [h, m, s] = String(t).split(':').map(Number);
          return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
        };
        const totalFormatted = convertSecToTimeFormat(times.reduce((sum, t) => sum + hmsToSec(t), 0));
        const rows = [
          ['For the Period', `${moment(start).format('YYYY-MM-DD')} to ${moment(end).format('YYYY-MM-DD')}`],
          ['Timezone', selectedTimezone],
          [],
          ['Member', ...dates.map((d) => moment(d).format('ddd, MMM D')), 'Total'],
          [name, ...times, totalFormatted],
        ];
        // Only add the holiday row when there is something to say, so an
        // ordinary week's CSV keeps the shape people already expect.
        if (holidayNames.some(Boolean)) rows.push(['Holiday', ...holidayNames, '']);
        setRangeCsvFilename(`Timesheet_${name.replace(/[^a-zA-Z0-9]/g, '')}_${moment(start).format('MM-DD-YYYY')}_to_${moment(end).format('MM-DD-YYYY')}.csv`);
        setRangeCsvRows(rows);
      } else {
        displayNotification({ message: 'There was an issue exporting the timesheet. Please try again', severity: 'error' });
      }
    } catch (err) {
      displayNotification({ message: 'There was an issue exporting the timesheet. Please try again', severity: 'error' });
    }
    setIsExporting(false);
  };

  // When CSV rows are ready, trigger the hidden download link and close the modal.
  useEffect(() => {
    if (rangeCsvRows.length > 0 && rangeCsvRef.current) {
      rangeCsvRef.current.link.click();
      setShowExportModal(false);
      setRangeCsvRows([]);
    }
  }, [rangeCsvRows]);

  const fetchDetail = async (selectedDate = date, selectedActivityType = activityType) => {
    // const startOfDay = moment(selectedDate).tz(timezone).startOf('day').utc();
    const formattedSelectedDay = moment(new Date(selectedDate)).format('"MM/DD/YYYY"');

    const startOfDay = moment.tz(formattedSelectedDay, 'MM/DD/YYYY', selectedTimezone).startOf('day').utc();
    const endOfDay = moment.tz(formattedSelectedDay, 'MM/DD/YYYY', selectedTimezone).endOf('day').utc();
    const params = {
      start: startOfDay.format('YYYY-MM-DD HH:mm:ss'),
      end: endOfDay.format('YYYY-MM-DD HH:mm:ss'),
      selectedTimezone,
    };

    if (selectedActivityType === 'Webcam Audit') {
      const res = await sendRequest({ method: 'get', url: API.MEMBER.webcamAudit(workspaceMember.id), params });
      if (res.success) {
        const data = res?.data?.list || [];
        const formattedWebcamAudit = res.data?.list?.length > 0
          ? formatWebcamAuditByDay(selectedTimezone, res.data.list) : {};
        setWebcamAudits({ data, formatted: formattedWebcamAudit });
      }
    } else {
      const res = await sendRequest({ method: 'get', url: API.MEMBER.activity(workspaceMember.id), params });
      if (res.success) {
        const data = res?.data?.list || [];
        let formattedSnapshots = {};
        let formattedAdditionalActivity = {};
        if (res.data?.list?.length > 0 || res.data?.manualEntries?.length > 0) {
          formattedSnapshots = formatSnapshotsByHour(
            selectedTimezone,
            res.data?.list || [],
            res.data?.manualEntries || [],
          );
          formattedAdditionalActivity = formatActivityByHour(selectedTimezone, res.data.list);
          setSelectedActivity(res.data.list);
          setSelectedActivity(res.data.list);
        }

        if (res.data?.manualEntries) setSelectedManualTime(res.data.manualEntries || []);
        setAdditionalTracking(formattedAdditionalActivity);
        setSnapshots({ data, formatted: formattedSnapshots });
      }
    }
  };

  const handleSelectDate = async (selectedDate, selectedActivityType, timezone = selectedTimezone) => {
    setDate(selectedDate);
    setActivityType(selectedActivityType);

    getTableData(selectedDate, timezone);

    if (showCaptures) {
      fetchDetail(selectedDate, selectedActivityType);
    }
  };

  const handleSelectTimezone = async (timezone, date, activityType) => {
    setSelectedTimezone(timezone);
    if (tabValue === 'Weekly') {
      await handleSelectDate(date, activityType, timezone);
    }
  };

  const fetchMemberInfo = async () => {
    const res = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getMember(activeWorkspace.id, memberId),
    });
    if (res.success) {
      setWorkspaceMember(res.data.member);
    } else if (res.status === 400) {
      displayNotification({
        message: res.data.error,
        severity: 'error',
      });
    } else if (res.status === 403) {
      displayNotification({
        message: 'You are not authorized to view this page',
        severity: 'error',
      });
      history.push('/');
    }
  };

  useEffect(() => {
    if (!workspaceMember) {
      fetchMemberInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (showCaptures) {
      fetchDetail();
    }
  }, [showCaptures]);

  useEffect(() => {
    if (workspaceMember) {
      handleSelectDate(date, activityType);
    }
  }, [workspaceMember]);

  // Fetch webcam audits when the Webcam Audit tab is selected
  useEffect(() => {
    if (value === 1 && showCaptures) {
      fetchDetail(date, 'Webcam Audit');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, showCaptures, date]);

  const snapshotsSortedByTime = useMemo(() => Object.keys(snapshots.formatted).sort(
    (a, b) => a.localeCompare(b, undefined, { numeric: true }),
  ), [snapshots]);

  const additionalActivitySortedByTime = useMemo(() => Object.keys(additionalTracking).sort(
    (a, b) => a.localeCompare(b, undefined, { numeric: true }),
  ), [snapshots]);

  const webcamAuditsSortedByTime = useMemo(
    () => Object.keys(webcamAudits.formatted).sort().reverse(),
    [webcamAudits],
  );

  const handleAddManualTime = () => {
    displayNotification({
      message: 'Manual time added successfully',
    });
    getTableData(date, selectedTimezone);
  };

  const handleOpenManualTimePopup = () => {
    if (!showCaptures) fetchDetail();
    setShowAddTimeModal(true);
  };

  const handleDeleteActivity = async (activityId) => {
    setActivityToDelete(activityId);
    setShowDeleteModal(true);
  };

  const confirmDeleteActivity = async () => {
    if (!activityToDelete) return;
    setDeletingActivityId(activityToDelete);
    try {
      const res = await sendRequest({
        method: 'delete',
        url: API.MEMBER.deleteActivity(memberId, activityToDelete),
      });
      if (res.success) {
        displayNotification({
          message: 'Activity deleted successfully',
          severity: 'success',
        });
        await handleSelectDate(date, activityType);
      }
    } finally {
      setDeletingActivityId(null);
      setActivityToDelete(null);
      setShowDeleteModal(false);
    }
  };

  const cancelDeleteActivity = () => {
    setShowDeleteModal(false);
    setActivityToDelete(null);
  };

  const memberFirstName = workspaceMember?.user?.firstName || '';
  const memberLastName = workspaceMember?.user?.lastName || '';
  const memberEmail = workspaceMember?.user?.email || '';
  const memberName = `${memberFirstName} ${memberLastName}`.trim() || memberEmail || 'Member';
  const avColors = avatarColors(memberEmail || memberName);
  // Make the member name link to their Account page, preserving the entry-point
  // (?from=) so the sidebar stays highlighted where the user came from.
  const memberProfileId = memberId || workspaceMember?.id;
  const memberFromParam = queryParams.get('from');
  const memberProfileTo = memberProfileId
    ? `/profile/${memberProfileId}${memberFromParam ? `?from=${memberFromParam}` : ''}`
    : null;
  // Key of the currently selected day, used to highlight its column in the week bar.
  const selectedKey = moment(date).format('MM/DD/YYYY');

  // A holiday lands on its own calendar date for everyone assigned to it. The
  // tooltip names the region it belongs to, which is descriptive only.
  const holidayTitle = (index) => {
    const name = tableData.holidayNames?.[index];
    if (!name) return undefined;
    const zone = tableData.holidayZones?.[index];
    return zone ? `${name} (observed in ${zone})` : name;
  };

  // Selection wins over the holiday tint, so clicking a holiday still reads as
  // the selected column.
  const dayTint = (index, highlight, base = '#ffffff') => {
    if (highlight) return '#eef5ea';
    if (tableData.holidayFlags?.[index]) return '#f3f9fe';
    return base;
  };

  const timezoneOptions = useMemo(() => {
    const opts = [];
    const seen = new Set();
    if (user?.timezone) {
      opts.push({ value: user.timezone, label: `Your timezone (${user.timezone})` });
      seen.add(user.timezone);
    }
    if (workspaceMember?.user?.timezone && !seen.has(workspaceMember.user.timezone)) {
      opts.push({
        value: workspaceMember.user.timezone,
        label: `${memberFirstName}'s Timezone (${workspaceMember.user.timezone})`,
      });
      seen.add(workspaceMember.user.timezone);
    }
    if (activeWorkspace?.timezone && !seen.has(activeWorkspace.timezone)) {
      opts.push({
        value: activeWorkspace.timezone,
        label: `${activeWorkspace.name} (${activeWorkspace.timezone})`,
      });
    }
    return opts;
  }, [user, workspaceMember, activeWorkspace, memberFirstName]);

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          {/* Title row */}
          <div className="flex flex-col gap-3 mb-5 lg:flex-row lg:items-center lg:justify-between">
            <div className="min-w-0 flex-1 flex items-center gap-2">
              {!isSelfView && (
                <button
                  type="button"
                  aria-label="Back"
                  onClick={() => history.goBack()}
                  className="p-1 -ml-1 rounded text-ink-900 hover:bg-gray-100 transition flex-shrink-0"
                >
                  <ArrowLeft size={22} />
                </button>
              )}
              <h1
                className="font-bold text-ink-900 leading-tight truncate text-xl lg:text-2xl"
                data-testid="title"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {`Timesheets: ${memberName}`}
              </h1>
            </div>

            {/* Header actions */}
            <div className="flex flex-wrap items-center gap-2 lg:gap-3 lg:flex-shrink-0">
              {tabValue === 'Weekly' ? (
                <PillDateButton
                  value={date}
                  onChange={(_date) => handleSelectDate(_date, activityType)}
                />
              ) : (
                <div style={{ minWidth: '246px' }}>
                  <DateRangePicker
                    value={dailyDate}
                    onChange={(_date) => setDailyDate(_date)}
                  />
                </div>
              )}

              <PillTimezoneSelect
                value={tabValue === 'Weekly' ? selectedTimezone : (activeWorkspace.timezone || selectedTimezone)}
                disabled={tabValue !== 'Weekly'}
                options={timezoneOptions}
                onChange={(e) => handleSelectTimezone(e.target.value, date, activityType)}
              />

              {/* Daily/Weekly toggle */}
              <div
                className="inline-flex p-1 rounded-[10px] bg-white"
                style={{ border: '1px solid #e0e1e6' }}
              >
                {tabOptions.map((opt) => {
                  const active = tabValue === opt.label;
                  return (
                    <button
                      key={opt.label}
                      type="button"
                      onClick={() => setTabValue(opt.label)}
                      className="rounded-[8px] transition capitalize"
                      style={{
                        padding: '6px 12px',
                        fontSize: '14px',
                        fontWeight: 500,
                        backgroundColor: active ? '#0e1e40' : 'transparent',
                        color: active ? '#ffffff' : '#0e1e40',
                      }}
                    >
                      {opt.label}
                    </button>
                  );
                })}
              </div>

              <button
                type="button"
                onClick={() => setShowExportModal(true)}
                className="inline-flex items-center gap-1.5 h-10 px-4 rounded-[8px] uppercase tracking-wider text-[#53A551] bg-white hover:bg-[#eef5ea] transition whitespace-nowrap"
                style={{ border: '1px solid #53A551', fontSize: 12, fontWeight: 600 }}
              >
                <Download size={12} />
                Export
              </button>

              {tabValue === 'Weekly' && tableData.isReportingManager && (
                <button
                  type="button"
                  onClick={handleOpenManualTimePopup}
                  disabled={!addable}
                  className="inline-flex items-center gap-1.5 h-10 px-4 rounded-[8px] bg-[#53A551] text-white hover:bg-[#458a44] transition disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                  style={{ fontSize: '14px', fontWeight: 600 }}
                >
                  <Plus size={14} />
                  Add time
                </button>
              )}

              {tabValue === 'Daily' && (
                <CSVLink data={exportData} headers={headers} filename="Report.csv">
                  <button
                    type="button"
                    className="inline-flex items-center gap-1.5 h-10 px-4 rounded-[8px] uppercase tracking-wider text-[#53A551] bg-white hover:bg-[#eef5ea] transition whitespace-nowrap"
                    style={{
                      border: '1px solid #53A551',
                      fontSize: '12px',
                      fontWeight: 600,
                    }}
                  >
                    <Download size={12} />
                    Export Table
                  </button>
                </CSVLink>
              )}
            </div>
          </div>

          {/* Export Timesheets modal */}
          {showExportModal && (
            <Modal open onClose={() => setShowExportModal(false)} className="flex-row align-c jstfy-c">
              <Box style={{
                width: 520, maxWidth: 'calc(100% - 32px)', background: '#fff', borderRadius: 12, fontFamily: 'Inter, sans-serif',
              }}
              >
                <div className="flex items-center justify-between px-6 pt-5 pb-3">
                  <h5 className="text-lg font-semibold leading-none text-ink-900">Export Timesheets</h5>
                  <button type="button" aria-label="Close" onClick={() => setShowExportModal(false)} className="text-ink-500 hover:text-ink-900 bg-transparent border-0 cursor-pointer p-0">
                    <X size={20} />
                  </button>
                </div>
                <div className="px-6 pt-2 pb-5 flex flex-col gap-4">
                  <div className="flex items-start gap-2 px-3 py-2.5 rounded-[8px]" style={{ background: '#f8f9ff', border: '1px solid #d6d9ff' }}>
                    <Info size={16} className="text-brand-500 flex-shrink-0" style={{ marginTop: 1 }} />
                    <p className="text-sm text-ink-700">Select the timesheet date range you wish to export</p>
                  </div>
                  <DSDateRangePicker value={exportRange} onChange={(r) => setExportRange(r || [new Date(), new Date()])} />
                </div>
                <div className="flex justify-end items-center gap-2 px-6 pb-5 pt-1">
                  <button type="button" onClick={() => setShowExportModal(false)} className="inline-flex items-center justify-center box-border h-10 px-4 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition" style={{ borderStyle: 'solid' }}>Cancel</button>
                  <button type="button" disabled={isExporting} onClick={handleExportTimesheet} className="inline-flex items-center justify-center box-border h-10 px-4 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition">
                    {isExporting ? 'Exporting…' : 'Export'}
                  </button>
                </div>
              </Box>
            </Modal>
          )}
          <CSVLink data={rangeCsvRows} filename={rangeCsvFilename} ref={rangeCsvRef} className="hidden" target="_blank" />

          {/* Weekly view */}
          {tabValue === 'Weekly' && (
            <>
              <ManualTimeModal
                showAddTimeModal={showAddTimeModal}
                setShowAddTimeModal={setShowAddTimeModal}
                workspaceMember={workspaceMember}
                selectedTimezone={selectedTimezone}
                selectedActivity={selectedActivity}
                selectedDate={date}
                selectedManualTime={selectedManualTime}
                handleAddManualTime={handleAddManualTime}
                projects={tableData.projects || []}
              />

              {/* Weekly table */}
              {(tableData.times.length > 0 && tableData.avgActivities.length > 0) && (
                <div
                  className="rounded-xl bg-white shadow-[0_1px_2px_rgba(14,30,64,0.04)] overflow-x-auto"
                  style={{ border: '1px solid #e8eaf0' }}
                >
                  <table className="w-full min-w-[800px]" style={{ borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid #f1f2f5' }}>
                        <th
                          className="text-left align-middle"
                          style={{
                            padding: '10px 20px',
                            minWidth: '200px',
                            fontWeight: 400,
                            backgroundColor: '#ffffff',
                          }}
                        >
                          <div className="flex items-center gap-3">
                            <div
                              className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
                              style={{
                                backgroundColor: avColors.bg,
                                color: avColors.fg,
                                fontSize: '12px',
                                fontWeight: 600,
                              }}
                            >
                              {initialsFrom(memberFirstName, memberLastName, memberEmail)}
                            </div>
                            <div className="min-w-0">
                              <Link
                                to={memberProfileTo || '#'}
                                className="text-brand-500 truncate hover:text-brand-700 hover:underline"
                                style={{
                                  fontSize: '14px', fontWeight: 500, lineHeight: '20px', margin: 0, display: 'block',
                                }}
                              >
                                {memberName}
                              </Link>
                              <p
                                className="text-ink-700 truncate"
                                style={{
                                  fontSize: '11px', fontWeight: 600, lineHeight: '16px', marginTop: 0, marginBottom: 0,
                                }}
                              >
                                {memberEmail}
                              </p>
                            </div>
                          </div>
                        </th>
                        {tableData.dates.map((d, idx) => {
                          const dayKey = moment(d).format('MM/DD/YYYY');
                          const isSelected = dayKey === selectedKey;
                          const highlight = isSelected;
                          const m = moment(d);
                          return (
                            <th
                              key={dayKey}
                              style={{
                                padding: '10px 12px',
                                backgroundColor: dayTint(idx, highlight),
                                cursor: 'pointer',
                                fontWeight: 400,
                              }}
                              title={holidayTitle(idx)}
                              onClick={() => handleSelectDate(m.toDate(), activityType)}
                            >
                              <div className="flex items-center justify-center gap-2">
                                <span
                                  className="tabular-nums"
                                  style={{
                                    fontSize: '30px',
                                    fontWeight: 600,
                                    lineHeight: '1',
                                    color: highlight ? '#53A551' : '#0e1e40',
                                  }}
                                >
                                  {m.format('D')}
                                </span>
                                <div className="text-left" style={{ lineHeight: '14px' }}>
                                  <div
                                    style={{
                                      fontSize: '11px',
                                      fontWeight: 600,
                                      color: highlight ? '#53A551' : '#0e1e40',
                                    }}
                                  >
                                    {m.format('ddd')}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: '11px',
                                      fontWeight: 400,
                                      color: highlight ? '#53A551' : '#546077',
                                    }}
                                  >
                                    {m.format('MMM')}
                                  </div>
                                </div>
                              </div>
                              {tableData.holidayFlags?.[idx] && (
                                <div
                                  style={{
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    color: '#0d47a1',
                                    marginTop: '2px',
                                    letterSpacing: '0.04em',
                                    textAlign: 'center',
                                  }}
                                >
                                  HOLIDAY
                                </div>
                              )}
                              {/* eslint-disable-next-line react/no-array-index-key */}
                              <span hidden>{idx}</span>
                            </th>
                          );
                        })}
                        <th
                          className="text-center text-ink-900"
                          style={{
                            padding: '10px 20px',
                            fontSize: '14px',
                            fontWeight: 600,
                            backgroundColor: '#ffffff',
                          }}
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Project rows */}
                      {tableData.projectTableData
                        && Object.entries(tableData.projectTableData)
                          .filter(([, p]) => p.totalSeconds > 0)
                          .map(([pid, p]) => (
                            <tr
                              key={`project-${pid}`}
                              style={{ borderBottom: '1px solid #f1f2f5' }}
                            >
                              <td
                                style={{
                                  padding: '12px 20px',
                                  fontSize: '14px',
                                }}
                              >
                                <div className="flex items-center gap-3 min-w-0">
                                  <div
                                    className="rounded-full flex items-center justify-center text-white flex-shrink-0"
                                    style={{
                                      width: '24px',
                                      height: '24px',
                                      backgroundColor: projectColor(p.name, pid),
                                      fontSize: '12px',
                                      fontWeight: 700,
                                    }}
                                  >
                                    {String(p.name || '?').charAt(0).toUpperCase()}
                                  </div>
                                  <span className="text-ink-900 truncate" style={{ fontWeight: 500 }}>
                                    {p.name}
                                  </span>
                                </div>
                              </td>
                              {p.times.map((time, i) => {
                                const dayKey = moment(tableData.dates[i]).format('MM/DD/YYYY');
                                const isSelected = dayKey === selectedKey;
                                const highlight = isSelected;
                                return (
                                  <td
                                    key={dayKey}
                                    className="text-center text-ink-900 tabular-nums"
                                    style={{
                                      padding: '12px',
                                      backgroundColor: dayTint(i, highlight, 'transparent'),
                                      fontSize: '14px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => handleSelectDate(new Date(tableData.dates[i]), activityType)}
                                  >
                                    {time !== '0:00:00' ? time : '-'}
                                  </td>
                                );
                              })}
                              <td
                                className="text-center text-ink-900 tabular-nums"
                                style={{ padding: '12px 20px', fontSize: '14px', fontWeight: 500 }}
                              >
                                {p.totalTime !== '0:00:00' ? p.totalTime : '-'}
                              </td>
                            </tr>
                          ))}

                      <tr style={{ borderBottom: '1px solid #f1f2f5' }}>
                        <td
                          className="text-ink-500"
                          style={{ padding: '16px 20px', fontSize: '14px' }}
                        >
                          Total
                        </td>
                        {tableData.times.map((t, i) => {
                          const dayKey = moment(tableData.dates[i]).format('MM/DD/YYYY');
                          const isSelected = dayKey === selectedKey;
                          const highlight = isSelected;
                          return (
                            <td
                              key={dayKey}
                              className="text-center text-ink-900 tabular-nums"
                              style={{
                                padding: '16px 12px',
                                backgroundColor: dayTint(i, highlight, 'transparent'),
                                fontSize: '14px',
                              }}
                              title={holidayTitle(i)}
                            >
                              {t}
                              {tableData.holidayFlags?.[i] && (
                                <div style={{ fontSize: '11px', color: '#0d47a1', marginTop: '2px' }}>
                                  {tableData.holidayNames?.[i]}
                                  {tableData.holidayTimes?.[i] ? ` · ${tableData.holidayTimes[i]}` : ''}
                                </div>
                              )}
                            </td>
                          );
                        })}
                        <td
                          className="text-center text-ink-900 tabular-nums"
                          style={{ padding: '16px 20px', fontSize: '14px', fontWeight: 600 }}
                        >
                          {tableData.totalTime}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="text-ink-500"
                          style={{ padding: '16px 20px', fontSize: '14px' }}
                        >
                          Avg Activity
                        </td>
                        {tableData.avgActivities.map((pct, i) => {
                          const dayKey = moment(tableData.dates[i]).format('MM/DD/YYYY');
                          const isSelected = dayKey === selectedKey;
                          const highlight = isSelected;
                          return (
                            <td
                              key={dayKey}
                              className="text-center tabular-nums"
                              style={{
                                padding: '16px 12px',
                                backgroundColor: dayTint(i, highlight, 'transparent'),
                                color: pct !== null ? activityColor(pct) : '#a8afbc',
                                fontSize: '14px',
                                fontWeight: 500,
                              }}
                            >
                              {pct !== null ? `${pct}%` : '--%'}
                            </td>
                          );
                        })}
                        <td
                          className="text-center tabular-nums"
                          style={{
                            padding: '16px 20px',
                            color: tableData.totalAvgActivity !== null ? activityColor(tableData.totalAvgActivity) : '#a8afbc',
                            fontSize: '14px',
                            fontWeight: 600,
                          }}
                        >
                          {tableData.totalAvgActivity !== null ? `${tableData.totalAvgActivity}%` : '--%'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* Webcam & Screenshots toggle */}
              <label
                className="inline-flex items-center gap-3 cursor-pointer select-none mt-5"
                style={{ marginTop: '20px' }}
              >
                <span
                  role="switch"
                  aria-checked={showCaptures}
                  onClick={() => setShowCaptures((v) => !v)}
                  className="relative inline-flex rounded-full transition"
                  style={{
                    width: '36px',
                    height: '20px',
                    backgroundColor: showCaptures ? '#53A551' : '#e8eaf0',
                  }}
                >
                  <span
                    className="absolute bg-white rounded-full shadow"
                    style={{
                      top: '2px',
                      left: '2px',
                      width: '16px',
                      height: '16px',
                      transform: showCaptures ? 'translateX(16px)' : 'translateX(0)',
                      transition: 'transform 200ms',
                    }}
                  />
                </span>
                <span className="text-ink-900" style={{ fontSize: '14px' }}>
                  Show Webcam &amp; Screenshots
                </span>
              </label>

              {/* Captures detail tabs */}
              {showCaptures && (
                <div className="mt-5 space-y-5">
                  {/* Tab bar */}
                  <div
                    className="flex items-center gap-6 overflow-x-auto"
                    style={{ borderBottom: '1px solid #e0e1e6' }}
                  >
                    {SCREENSHOT_TABS.map((t) => {
                      const active = value === t.id;
                      return (
                        <button
                          key={t.id}
                          type="button"
                          onClick={() => setValue(t.id)}
                          className="relative whitespace-nowrap transition"
                          style={{
                            paddingBottom: '12px',
                            fontSize: '14px',
                            fontWeight: 500,
                            color: active ? '#213d69' : '#546077',
                          }}
                        >
                          {t.label}
                          {active && (
                            <span
                              className="absolute left-0 right-0 rounded-full"
                              style={{
                                bottom: '-1px',
                                height: '2px',
                                backgroundColor: '#213d69',
                              }}
                            />
                          )}
                        </button>
                      );
                    })}
                  </div>

                  {value === 0 && (
                    <div>
                      {snapshotsSortedByTime.map((snapshotHour) => (
                        <SnapshotRow
                          key={snapshotHour}
                          hourBlock={snapshotHour}
                          snapshots={snapshots.formatted[snapshotHour]}
                          blurScreenshots={workspaceMember.blurScreenshots}
                          isAdmin={isAdmin}
                          onDeleteActivity={handleDeleteActivity}
                          deletingActivityId={deletingActivityId}
                        />
                      ))}
                    </div>
                  )}

                  {value === 1 && (
                    <div>
                      {webcamAuditsSortedByTime.map((webcamAuditDay) => (
                        <AuditRow
                          key={webcamAuditDay}
                          dayBlock={webcamAuditDay}
                          webcamAudits={webcamAudits.formatted[webcamAuditDay]}
                        />
                      ))}
                    </div>
                  )}

                  {value === 2 && (
                    <div>
                      <div
                        className="grid grid-cols-4 px-3 mb-3 text-ink-500 uppercase tracking-wider"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                      >
                        <div>Project</div>
                        <div>Website</div>
                        <div>URL</div>
                        <div className="text-right">Time Spent</div>
                      </div>
                      {additionalActivitySortedByTime.map((snapshotHour, index) => {
                        const hourData = additionalTracking[snapshotHour];
                        return (
                          <UrlActivity
                            key={`url-activity-${snapshotHour}-${index}`}
                            additionalProperty="browserActivity"
                            hourBlock={snapshotHour}
                            data={hourData}
                            projects={tableData.projects || []}
                            totalSecondsElapsed={hourData?.totalSecondsElapsed || 0}
                          />
                        );
                      })}
                    </div>
                  )}

                  {value === 3 && (
                    <div>
                      <div
                        className="grid grid-cols-4 px-3 mb-3 text-ink-500 uppercase tracking-wider"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                      >
                        <div>Project</div>
                        <div>Application</div>
                        <div className="text-right">Time Spent</div>
                        <div className="text-right">Sessions</div>
                      </div>
                      {additionalActivitySortedByTime.map((snapshotHour, index) => {
                        const hourData = additionalTracking[snapshotHour];
                        return (
                          <AppActivity
                            key={`app-activity-${snapshotHour}-${index}`}
                            additionalProperty="appActivity"
                            hourBlock={snapshotHour}
                            data={hourData}
                            projects={tableData.projects || []}
                          />
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          {/* Daily view */}
          {tabValue === 'Daily' && (
            <>
              {/* Daily card */}
              <div
                className="rounded-xl bg-white shadow-[0_1px_2px_rgba(14,30,64,0.04)] overflow-hidden"
                style={{ border: '1px solid #e8eaf0' }}
              >
                <div
                  className="flex items-center px-5 py-4"
                  style={{ borderBottom: '1px solid #f1f2f5' }}
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <div
                      className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{
                        backgroundColor: avColors.bg,
                        color: avColors.fg,
                        fontSize: '12px',
                        fontWeight: 600,
                      }}
                    >
                      {initialsFrom(memberFirstName, memberLastName, memberEmail)}
                    </div>
                    <div className="min-w-0">
                      <Link
                        to={memberProfileTo || '#'}
                        className="text-ink-900 truncate hover:text-brand-700 hover:underline"
                        style={{
                          fontSize: '14px', fontWeight: 600, lineHeight: '20px', margin: 0, display: 'block',
                        }}
                      >
                        {memberName}
                      </Link>
                      <p
                        className="text-ink-700 truncate"
                        style={{
                          fontSize: '11px', fontWeight: 600, lineHeight: '16px', marginTop: 0, marginBottom: 0,
                        }}
                      >
                        {memberEmail}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="grid grid-cols-[1fr_180px_180px] items-center px-5 py-3 text-ink-500"
                  style={{
                    borderBottom: '1px solid #f1f2f5',
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                >
                  <span>Date</span>
                  <span className="text-right">Duration</span>
                  <span className="text-right pr-2">Engagement Score</span>
                </div>
                {dailyTableData.length === 0 && (
                  <div
                    className="px-5 py-8 text-center text-ink-500"
                    style={{ fontSize: '14px' }}
                  >
                    No activity in selected range.
                  </div>
                )}
                {dailyTableData.map((day, idx) => {
                  const isOpen = openDays.has(idx);
                  return (
                    <div key={day.date || idx}>
                      <div
                        className="px-5 py-2 bg-surface-page text-ink-500 uppercase tracking-wider"
                        style={{
                          fontSize: '11px',
                          fontWeight: 600,
                          letterSpacing: '0.05em',
                        }}
                      >
                        {day.date}
                      </div>
                      <button
                        type="button"
                        onClick={() => toggleDailyDay(idx)}
                        className="w-full grid grid-cols-[1fr_180px_180px] items-center px-5 py-3 hover:bg-surface-page transition"
                        style={{ fontSize: '14px' }}
                      >
                        <span className="flex items-center gap-2 text-ink-900" style={{ fontWeight: 500 }}>
                          <ChevronRight
                            size={14}
                            className="text-ink-500"
                            style={{
                              transition: 'transform 200ms',
                              transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                            }}
                          />
                          Total
                        </span>
                        <span className="text-right text-ink-900 tabular-nums">
                          {convertSecToTimeFormat(day.totalSeconds || 0)}
                        </span>
                        <span className="text-right pr-2 text-ink-900 tabular-nums">
                          {day.totalSeconds > 0 ? `${day.totalActivity}%` : '0%'}
                        </span>
                      </button>
                      {isOpen && [
                        { id: 'deep', duration: day.deepFocused },
                        { id: 'focused', duration: day.focused },
                        { id: 'active', duration: day.active },
                        { id: 'break', duration: day.workBreak },
                        { id: 'manual', duration: day.manualSeconds },
                      ].map((a) => {
                        const meta = ACTIVITY_META.find((x) => x.id === a.id);
                        const workingSec = Math.max((day.totalSeconds || 0) - (day.workBreak || 0), 0);
                        const score = meta.noScore || workingSec === 0
                          ? '—'
                          : `${Math.round(((a.duration || 0) / workingSec) * 100)}%`;
                        return (
                          <div
                            key={a.id}
                            className="grid grid-cols-[1fr_180px_180px] items-center px-5 py-3"
                            style={{
                              borderTop: '1px solid #f1f2f5',
                              fontSize: '14px',
                            }}
                          >
                            <span className="flex items-center gap-3 text-ink-900">
                              <ActivityBadge activityId={a.id} />
                              {meta.label}
                            </span>
                            <span className="text-right text-ink-900 tabular-nums">
                              {convertSecToTimeFormat(a.duration || 0)}
                            </span>
                            <span className="text-right pr-2 text-ink-500 tabular-nums">
                              {score}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={showDeleteModal}
        onClose={cancelDeleteActivity}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Delete Activity
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this activity?
            This action cannot be undone and will remove data from all activity-related tables.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDeleteActivity} color="primary">
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteActivity}
            color="error"
            variant="contained"
            autoFocus
            disabled={!!deletingActivityId}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ViewActivity;
